import React from 'react';
import { Pressable, View } from 'react-native';
import { Icon, type IconName } from './Icon';
import { Text } from './Text';
import { radius, toneColors, useTheme, type Tone } from './theme';

export function StatCard({ label, value, hint, icon, tone = 'primary', onPress, testID }: { label: string; value: React.ReactNode; hint?: string; icon?: IconName; tone?: Tone; onPress?: () => void; testID?: string }) {
  const { colors } = useTheme();
  const t = toneColors(colors, tone);
  return (
    <Pressable
      testID={testID}
      disabled={!onPress}
      onPress={onPress}
      accessibilityRole={onPress ? 'button' : undefined}
      style={({ pressed }) => ({ backgroundColor: pressed ? colors.hover : colors.surface, borderRadius: radius.lg, borderWidth: 1, borderColor: colors.border, padding: 14, gap: 6, flex: 1 })}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
        {icon && (
          <View style={{ width: 28, height: 28, borderRadius: 8, backgroundColor: t.bg, alignItems: 'center', justifyContent: 'center' }}>
            <Icon name={icon} size={15} color={t.fg} />
          </View>
        )}
        <Text variant="muted" numberOfLines={1} style={{ flex: 1 }}>
          {label}
        </Text>
      </View>
      {typeof value === 'string' || typeof value === 'number' ? <Text variant="value">{value}</Text> : value}
      {!!hint && (
        <Text variant="small" numberOfLines={1}>
          {hint}
        </Text>
      )}
    </Pressable>
  );
}
